import * as React from "react";
function ButtonRoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13.5,
    fill: "currentColor",
    opacity: 0.2,
    rx: 10,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.917 14.333h4.166l.75 1.834h1.75L12.625 7h-1.25l-3.958 9.167h1.75l.75-1.834zM12 8.65l1.558 4.183h-3.116L12 8.65z"
  }));
}
const ForwardRef = React.forwardRef(ButtonRoundIcon);
export default ForwardRef;